import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectTravellerMedicalBenefitsTugo = (state) => state.get('travellerMedicalBenefitsTugo');

const makeSelectTravellerMedicalBenefitsTugo = () => createSelector(
  selectTravellerMedicalBenefitsTugo,
  (travellerMedicalBenefitsTugoState) => ({

    whatExpensesAreYouClaimingFor: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      []
    ),

    // Doctor Visit selectors
    doctorVisitTelemedicine: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'doctorVisitTelemedicine']),
      ''
    ),
    doctorVisitByPhone: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'doctorVisitByPhone']),
      false
    ),
    doctorVisitInPerson: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'doctorVisitInPerson']),
      false
    ),
    doctorVisitFirstVisit: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFirstVisit']),
      ''
    ),
    doctorVisitFollowUp: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFollowUp']),
      ''
    ),
    infoOutpatientPhysicianFeesItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoOutpatientPhysicianFeesItems']),
      []
    ),
    infoFollowUpVisitItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpVisitItems']),
      []
    ),
    infoTelemedicineItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoTelemedicineItems']),
      []
    ),
    doctorVisitFollowUpFracture: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFollowUpFracture']),
      ''
    ),
    infoFollowUpFractureItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpFractureItems']),
      []
    ),

    // Diagnostic Tests
    infoDiagnosticTestsItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoDiagnosticTestsItems']),
      []
    ),

    // Prescription Drugs
    prescriptionDrugsLost: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'prescriptionDrugsLost']),
      ''
    ),
    infoPrescriptionDrugsItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoPrescriptionDrugsItems']),
      []
    ),

    // Ambulance Services
    ambulanceGroundService: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'ambulanceGroundService']),
      ''
    ),
    ambulanceAirService: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'ambulanceAirService']),
      ''
    ),
    infoGroundAmbulanceItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoGroundAmbulanceItems']),
      []
    ),
    infoAirAmbulanceItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAirAmbulanceItems']),
      []
    ),
    infoOtherAmbulanceItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoOtherAmbulanceItems']),
      []
    ),

    // Hospitalization
    hospitalizationHospitalFees: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationHospitalFees']),
      false
    ),
    hospitalizationInpatientPhysicianFees: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationInpatientPhysicianFees']),
      false
    ),
    hospitalizationXrayLabsDiagnostics: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationXrayLabsDiagnostics']),
      false
    ),
    hospitalizationEmergencyAirTransportation: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationEmergencyAirTransportation']),
      false
    ),
    hospitalizationAirfareReturnHome: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationAirfareReturnHome']),
      false
    ),
    hospitalizationFamilyTransportation: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationFamilyTransportation']),
      false
    ),
    hospitalizationFamilyTransportationMealsAccommodation: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationFamilyTransportationMealsAccommodation']),
      false
    ),
    hospitalizationMedicalAttendant: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalAttendant']),
      false
    ),
    hospitalizationReturnOfTravellingCompanion: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfTravellingCompanion']),
      false
    ),
    hospitalizationReturnOfDependentChildren: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfDependentChildren']),
      false
    ),
    hospitalizationHospitalAllowance: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationHospitalAllowance']),
      false
    ),
    hospitalizationOutOfPocketExpenses: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationOutOfPocketExpenses']),
      false
    ),
    hospitalizationChildcare: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationChildcare']),
      false
    ),
    hospitalizationReturnOfVehicle: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfVehicle']),
      false
    ),
    hospitalizationOtherRelated: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationOtherRelated']),
      false
    ),
    hospitalizationAirlineSeatUpgrade: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationAirlineSeatUpgrade']),
      false
    ),
    hospitalizationReturnOfPets: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfPets']),
      false
    ),
    hospitalizationMedicalFollowUpInCanada: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalFollowUpInCanada']),
      false
    ),
    hospitalizationMedicalFollowUpInCanadaSemiPrivate: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalFollowUpInCanadaSemiPrivate']),
      false
    ),
    hospitalizationMedicalFollowUpInCanadaAmbulance: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalFollowUpInCanadaAmbulance']),
      false
    ),
    hospitalizationMedicalFollowUpInCanadaHomeCare: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalFollowUpInCanadaHomeCare']),
      false
    ),
    hospitalizationMedicalFollowUpInCanadaEssentialMedicalApp: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalFollowUpInCanadaEssentialMedicalApp']),
      false
    ),
    hospitalizationReturnToYourDestination: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnToYourDestination']),
      false
    ),
    infoHospitalFeesItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoHospitalFeesItems']),
      []
    ),
    infoInpatientPhysicianFeesItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoInpatientPhysicianFeesItems']),
      []
    ),
    infoXrayLabsDiagnosticsItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoXrayLabsDiagnosticsItems']),
      []
    ),
    infoEmergencyAirTransportationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoEmergencyAirTransportationItems']),
      []
    ),
    infoAirfareReturnHomeItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAirfareReturnHomeItems']),
      []
    ),
    infoFamilyTransportationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationItems']),
      []
    ),
    infoFamilyTransportationMealsAccommodationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationMealsAccommodationItems']),
      []
    ),
    infoMedicalAttendantItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoMedicalAttendantItems']),
      []
    ),
    infoReturnOfTravellingCompanionItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfTravellingCompanionItems']),
      []
    ),
    infoReturnOfDependentChildrenItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfDependentChildrenItems']),
      []
    ),
    infoHospitalAllowanceItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoHospitalAllowanceItems']),
      []
    ),
    infoOutOfPocketExpensesItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoOutOfPocketExpensesItems']),
      []
    ),
    infoChildcareItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoChildcareItems']),
      []
    ),
    infoReturnOfVehicleItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleItems']),
      []
    ),
    returnOfVehicleCommercialAgency: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'returnOfVehicleCommercialAgency']),
      false
    ),
    returnOfVehicleFamilyMemberFriend: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'returnOfVehicleFamilyMemberFriend']),
      false
    ),
    infoReturnOfVehicleCommercialAgencyItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleCommercialAgencyItems']),
      []
    ),
    infoReturnOfVehicleFamilyMemberFriendItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleFamilyMemberFriendItems']),
      []
    ),
    infoOtherHospitalizationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoOtherHospitalizationItems']),
      []
    ),
    infoAirlineSeatUpgradeItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAirlineSeatUpgradeItems']),
      []
    ),
    infoReturnOfPetsItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfPetsItems']),
      []
    ),
    infoHospitalizationReturnOfVehicleItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoHospitalizationReturnOfVehicleItems']),
      []
    ),
    infoMedicalFollowUpInCanadaSemiPrivateItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoMedicalFollowUpInCanadaSemiPrivateItems']),
      []
    ),
    infoMedicalFollowUpInCanadaAmbulanceItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoMedicalFollowUpInCanadaAmbulanceItems']),
      []
    ),
    infoMedicalFollowUpInCanadaHomeCareItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoMedicalFollowUpInCanadaHomeCareItems']),
      []
    ),
    infoMedicalFollowUpInCanadaEssentialMedicalAppItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoMedicalFollowUpInCanadaEssentialMedicalAppItems']),
      []
    ),
    infoReturnToYourDestinationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoReturnToYourDestinationItems']),
      []
    ),

    // Essential Medical Equipment
    infoEssentialMedicalEquipmentItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoEssentialMedicalEquipmentItems']),
      []
    ),

    // Private Duty Nursing
    infoPrivateDutyNursingItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoPrivateDutyNursingItems']),
      []
    ),

    // Fracture Treatment
    infoFractureTreatmentItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoFractureTreatmentItems']),
      []
    ),

    // Accidental Death and Dismemberment Benefits (benefit removed from selection; field retained so historical claims with AD&D data load/save intact)
    infoAccidentalDeathAndDismembermentItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAccidentalDeathAndDismembermentItems']),
      []
    ),

    // Expenses Related to Death
    expensesRelatedToDeathReturnRemains: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'expensesRelatedToDeathReturnRemains']),
      false
    ),
    expensesRelatedToDeathBurialCremation: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'expensesRelatedToDeathBurialCremation']),
      false
    ),
    expensesRelatedToDeathFamilyTransportation: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'expensesRelatedToDeathFamilyTransportation']),
      false
    ),
    infoExpensesRelatedToDeathReturnRemainsItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoExpensesRelatedToDeathReturnRemainsItems']),
      []
    ),
    infoExpensesRelatedToDeathBurialCremationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoExpensesRelatedToDeathBurialCremationItems']),
      []
    ),
    infoExpensesRelatedToDeathFamilyTransportationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoExpensesRelatedToDeathFamilyTransportationItems']),
      []
    ),

    // Maternity Benefits
    maternityBenefitsDateOfConception: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'maternityBenefitsDateOfConception']),
      ''
    ),
    maternityBenefitsAnticipatedDueDate: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'maternityBenefitsAnticipatedDueDate']),
      ''
    ),
    infoUnexpectedBirthOfChildItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoUnexpectedBirthOfChildItems']),
      []
    ),

    // Dental Services
    dentalServicesDentalAccident: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'dentalServicesDentalAccident']),
      false
    ),
    dentalServicesDentalPainOther: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'dentalServicesDentalPainOther']),
      false
    ),
    infoDentalAccidentItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoDentalAccidentItems']),
      []
    ),
    infoDentalPainOtherItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoDentalPainOtherItems']),
      []
    ),

    // Professional Services
    professionalServices: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServices']),
      false
    ),
    professionalServicesPhysiotherapist: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServicesPhysiotherapist']),
      false
    ),
    professionalServicesChiropractor: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServicesChiropractor']),
      false
    ),
    professionalServicesChiropodist: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServicesChiropodist']),
      false
    ),
    professionalServicesOsteopath: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServicesOsteopath']),
      false
    ),
    professionalServicesPodiatrist: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServicesPodiatrist']),
      false
    ),
    professionalServicesAcupuncturist: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServicesAcupuncturist']),
      false
    ),
    professionalServicesOptometrist: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'professionalServicesOptometrist']),
      false
    ),
    infoPhysiotherapistItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoPhysiotherapistItems']),
      []
    ),
    infoChiropractorItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoChiropractorItems']),
      []
    ),
    infoChiropodistItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoChiropodistItems']),
      []
    ),
    infoOsteopathItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoOsteopathItems']),
      []
    ),
    infoPodiatristItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoPodiatristItems']),
      []
    ),
    infoAcupuncturistItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAcupuncturistItems']),
      []
    ),
    infoOptometristItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoOptometristItems']),
      []
    ),
    // Remote Evacuation
    infoRemoteEvacuationItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoRemoteEvacuationItems']),
      []
    ),

    // Vision Care and Hearing Aids
    infoVisionCareHearingAidsItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoVisionCareHearingAidsItems']),
      []
    ),

    // Air Travel Delay
    airTravelDelayHotelOrRestaurant: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'airTravelDelayHotelOrRestaurant']),
      false
    ),
    airTravelDelayAdditionalTransport: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'airTravelDelayAdditionalTransport']),
      false
    ),
    airTravelDelayEntertainment: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'airTravelDelayEntertainment']),
      false
    ),
    airTravelDelayEssentialClothing: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'airTravelDelayEssentialClothing']),
      false
    ),
    infoAirTravelDelayHotelOrRestaurantItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAirTravelDelayHotelOrRestaurantItems']),
      []
    ),
    infoAirTravelDelayAdditionalTransportItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAirTravelDelayAdditionalTransportItems']),
      []
    ),
    infoAirTravelDelayEntertainmentItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAirTravelDelayEntertainmentItems']),
      []
    ),
    infoAirTravelDelayEssentialClothingItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoAirTravelDelayEssentialClothingItems']),
      []
    ),

    infoOtherUnrelatedBenefitItems: mapWithDefault(
      travellerMedicalBenefitsTugoState,
      () => travellerMedicalBenefitsTugoState.getIn(['form', 'infoOtherUnrelatedBenefitItems']),
      []
    ),
  })
);

const makeSelectTravellerMedicalBenefitsTugoErrors = () => createSelector(
  selectTravellerMedicalBenefitsTugo,
  (travellerMedicalBenefitsTugoState) => mapWithDefault(
    travellerMedicalBenefitsTugoState,
    () => travellerMedicalBenefitsTugoState.get('errors'),
    []
  )
);

export {
  makeSelectTravellerMedicalBenefitsTugo,
  makeSelectTravellerMedicalBenefitsTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TravellerMedicalBenefits/selectors.js